// extracted by mini-css-extract-plugin
export default {"picker":"legend_picker__PJn7c","container":"legend_container__FvZiq","item":"legend_item__xyC3Y"};